module.exports = require("core-js/modules/es.typed-array.reduce-right.js");